import { getIpeUserLocalOwnerId, userLocal } from '@/utils/ipeUserLocalState';

const TEMPLATE_EDITOR_KEY_PREFIX = 'funding_template_editor_';

export function getTemplateEditorItem(name) {
  return userLocal.getItem(name);
}

export function setTemplateEditorItem(name, value) {
  return userLocal.setItem(name, value);
}

export function removeTemplateEditorItem(name) {
  userLocal.removeItem(name);
}

export function dropLegacyTemplateEditorKeys() {
  userLocal.dropLegacyKeyPrefix(TEMPLATE_EDITOR_KEY_PREFIX);
}

export function clearTemplateEditorLocalForLogout() {
  dropLegacyTemplateEditorKeys();
}

/**
 * 列出当前用户作用域下、以 prefix 开头的模板编辑器 name（非完整 localStorage key）。
 * @param {string} prefix
 * @returns {string[]}
 */
export function listTemplateEditorNamesWithPrefix(prefix) {
  const owner = getIpeUserLocalOwnerId();
  const p = String(prefix || '').trim();
  if (!owner || !p) return [];
  const scopedPrefix = `ipe:u:${owner}:${p}`;
  const names = [];
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(scopedPrefix)) continue;
      names.push(key.slice(`ipe:u:${owner}:`.length));
    }
  } catch {
    /* ignore */
  }
  return names;
}
